import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'utcToLocal' })
export class UtcToLocalPipe implements PipeTransform {
  transform(value: Date | string | null | undefined): Date | null {
    if (!value) {
      return null;
    }

    // If the string already contains timezone info (Z suffix or ±HH:MM offset),
    // the Date constructor will parse it correctly — no correction needed.
    if (typeof value === 'string' && /Z|[+-]\d{2}:\d{2}$/.test(value)) {
      const date = new Date(value);
      return isNaN(date.getTime()) ? null : date;
    }

    const date = value instanceof Date ? value : new Date(value);

    if (isNaN(date.getTime())) {
      return null;
    }

    // The API returns UTC datetimes without a 'Z' suffix, so the Date
    // constructor treats them as local time. Subtract the timezone offset
    // to reinterpret the value as UTC.
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  }
}
